<div class="modal-dialog modal-lg" role="document">
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title text-truncate" [matTooltip]="rental.name" matTooltipPosition="below">
        <ng-container i18n>Delete Rental</ng-container> - {{ rental.name }}
      </h5>
      <a (click)="close()" class="cstm-close">
        <span class="far fa-times"></span>
      </a>
    </div>
    <div class="modal-body">
      <div class="container-box border p-4">
        <div i18n>
          You are attempting to delete a rental. In order to delete a rental from AdvanceCM you must first delete any
          hold events, inquiries, bookings and website associations before doing so. Please use the options below to
          complete these tasks. Please note that all associated hold events, bookings, invoices and messages will be
          purged and will not be recoverable. This will also impact data shown in your reports as these items will no
          longer be accessible for calculation by the reporting module. Please acknowledge that you are fully aware of
          the consequences by selecting checkboxes and then use the buttons below to initiate the deletion of these
          items.
        </div>

        <div class="mt-3">
          <ol class="notes-list">
            <li i18n>
              This rental will be disconnected from all API channels. If the channel connection is no longer valid it
              should be removed from AdvanceCM.
            </li>
            <li i18n>All rental images and other associated data will be removed.</li>
            <li i18n>All imported and exported iCal calendars will be deleted.</li>
            <li i18n>This rental will no longer be displayed on distribution channels like Marriott.</li>
            <li i18n>You must remove all bookings, hold events, and website associations related to this rental.</li>
            <li i18n>This rental will be deactivated in all connected Tokeet and partner applications.</li>
          </ol>
        </div>

        <div class="mt-5">
          <div class="actions-list-title" i18n>
            Some of these services can be deleted from your account individually
          </div>
          <div class="actions-list row">
            <div class="col-sm-6">
              <div class="action-item" [class.disabled]="!tokeetRentalData.holdEvents || isHoldDeleted">
                <i class="far fa-calendar-times action-icon"></i>
                <div class="action-info-wrapper">
                  <div class="action-title" i18n>Hold Events</div>
                  <div class="action-description">
                    {{ tokeetRentalData.holdEvents }} <ng-container i18n>Hold Events Created</ng-container>
                  </div>
                </div>
                <div>
                  <i class="fas fa-trash action-btn" (click)="onDeleteHold()"></i>
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div
                class="action-item"
                [class.disabled]="!tokeetRentalData.bookings || isBookingsDeleted || isDeletingBookings"
              >
                <i class="far fa-calendar-check action-icon"></i>
                <div class="action-info-wrapper">
                  <div class="action-title" i18n>Inquiries & Bookings</div>
                  <div class="action-description">
                    {{ tokeetRentalData.bookings }} <ng-container i18n>Inquiries & Bookings Created</ng-container>
                  </div>
                </div>
                <div>
                  <i class="fas fa-trash action-btn" (click)="onDeleteBookings()"></i>
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="action-item" [class.disabled]="!tokeetRentalData.websites || isWebsitesDeleted">
                <i class="far fa-browser action-icon"></i>
                <div class="action-info-wrapper">
                  <div class="action-title" i18n>Websites Associations</div>
                  <div class="action-description">
                    {{ tokeetRentalData.websites }} <ng-container i18n>Website Associations</ng-container>
                  </div>
                </div>
                <div>
                  <i class="fas fa-trash action-btn" (click)="onDeleteWebsites()"></i>
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="action-item" [class.disabled]="!webreadyRentalData.rental || isWebreadyRentalDeleted">
                <i class="far fa-globe action-icon"></i>
                <div class="action-info-wrapper">
                  <div class="action-title" i18n>Rental in Webready</div>
                  <div class="action-description">
                    <ng-container i18n>Used in</ng-container> {{ webreadyRentalData.websites }}
                    <ng-container i18n>Websites, contains</ng-container> {{ webreadyRentalData.images }}
                    <ng-container i18n>Images</ng-container>
                  </div>
                </div>
                <div>
                  <i class="fas fa-trash action-btn" (click)="onDeleteWebreadyData()"></i>
                </div>
              </div>
            </div>
            <div class="col-sm-12 mt-5">
              <div class="row">
                <div class="offset-sm-3"></div>
                <div class="col-sm-6">
                  <div class="action-item delete-rental-item" [class.disabled]="!isAllDeleted">
                    <i class="far fa-building action-icon"></i>
                    <div class="action-info-wrapper">
                      <div class="action-title" i18n>Delete Whole Rental</div>
                      <div class="action-description" i18n>All Service Associated with this rental will be deleted</div>
                    </div>
                    <div>
                      <i class="fas fa-trash action-btn" (click)="onDelete()"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
